import $ from 'jquery';

export const openDocumentsInNewTab = () => {
  $('a[href$=".pdf"],a[href$=".doc"],a[href$=".docx"],a[href$=".xls"],a[href$=".xlsx"],a[href$=".ppt"],a[href$=".pttx"],a[href$=".ppsx"]')
      .attr('target', '_blank');
};

export const openExternalLinksInNewTab = () => {
  $('a')
      .not('[target=_blank]')
      .not('[href*="' + location.hostname + '"]')
      .not('[href^="/"]')
      .attr('target', '_blank');
};


// WEBPACK FOOTER //
// ./scripts/lib/dom/links.js